import { openBlock as e, createElementBlock as c, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M6.737 1.839C6.883.968 7.604.25 8.55.25c.674 0 1.234.364 1.553.888a1.79 1.79 0 0 1 .627-.112c1.062 0 1.84.904 1.84 1.914v.445c.11-.02.223-.032.34-.032 1.062 0 1.84.904 1.84 1.914v5.595c0 2.7-2.188 4.888-4.888 4.888H6.024l-4.398-5.165-.02-.028a1.985 1.985 0 0 1 .169-2.48 1.802 1.802 0 0 1 2.651 0l.104.111V3.716c0-1.01.779-1.914 1.84-1.914.127 0 .25.013.367.037Zm.413 1.877c0-.276-.293-.414-.529-.414-.236 0-.59.138-.59.414v8.268l-2.7-2.882a.303.303 0 0 0-.461 0 .486.486 0 0 0-.05.57l3.897 4.578h3.145a3.388 3.388 0 0 0 3.388-3.388V5.267c0-.275-.387-.414-.583-.414-.25 0-.56.139-.56.414V7.76h-.878V2.94c0-.275-.264-.413-.6-.413-.336 0-.629.138-.629.414V7.76h-.822V2.164c0-.276-.28-.414-.596-.414-.316 0-.586.138-.586.414v5.595H7.15V3.716Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  l
];
function r(d, a) {
  return e(), c("svg", o, [...n]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
